<template lang='pug'>
.product-detail-container
    .content-wrapper
        div(:class='isBoldTitle ? "bold-title" : "detail-title"') {{ product.name }}
        img.banner(v-src='product.banner', v-if='product.banner')
        .content(v-html='product.desc')
    .cases-wrapper(v-if='cases')
        router-link.item(
            v-for='caseName in cases',
            :to='{ name: "levelPageWithLabel", params: { rId, name: caseName, } }'
        ) {{ caseName }}
    .pdf-wrapper(v-if='pdfs[0]')
        .pdf-item
            .head
                h4 资料下载
                router-link.more(
                    v-if='pdfs.length > 1',
                    :to='{ name: "documentList", params: {  type: "pdf", rId }, query: {hId: this.hId} }'
                ) 更多 &gt;&gt;
            DocumentPanelVue(:info='pdfs[0]')
    .button-group
        router-link.button-item(
            v-if='videoList.length',
            :to='{ name: "documentList", params: { type: "video", rId }, query: {hId: this.hId} }'
        ) 精彩视频
        .button-item(
            v-if='product.selectLink',
            @click='jump(product.selectLink)'
        ) 产品选型
        .button-item(v-if='product.btnLink', @click='jump(product.btnLink)') {{ product.btnText }}
        router-link.button-item(
            v-for='item in relatedProducts',
            :key="item.id"
            :to='{ name: "productDetail", params: { rId: item.id } }'
        ) {{ item.detail.name }}
</template>

<script>
import dataDic from '@/assets/data/dic'
import { getResizeParam, getVideoProcesser, getImgProcesser, getSuffix } from '@/plugins/utils'
import DocumentPanelVue from './components/Panel/DocumentPanelVue'
import { mapActions } from 'vuex'
import { concatWithSymbol, getDataPaths, getDataRow, getPathNames } from '@custouch/proxy-use'
export default {
    props: ['rId', 'hId'],
    data() {
        return {
            product: {},
            pdfs: [],
            relatedProducts: null,
            cases: null,
            isBoldTitle: false,
            videoList: []
        }
    },
    components: {
        DocumentPanelVue,
    },
    methods: {
        ...mapActions(['getJson']),
        jump(link) {
            window.location.href = link
            this.$message.loading({
                message: '跳转中...',
                forbidClick: true,
                duration: 3000
            })
        },
        getIsBoldTitle(path){
            let curH = path.dataHierarchy
            const hIds = []
            while (curH){
                hIds.push(curH.id)
                curH = curH.dataHierarchy
            }
            const { module } = window.env.DATA
            return hIds.includes(module.productTech.hierarchies.Application)
        },
        async initData() {
            const data = await getDataRow({dataRowId: this.rId})
            this.product = data.detail
            let title = concatWithSymbol([this.$route.meta.title,data.detail.name])
            if(this.hId){
                const [names, [path]] = await Promise.all([
                    getPathNames(this.hId,data.detail.name),
                    getDataPaths({dataHierarchyId: this.hId})
                ])
                title = names
                this.isBoldTitle = this.getIsBoldTitle(path)
            }
            if(data.dataRows.length){
                const { DATA } = window.env
                const { template } = DATA
                this.pdfs = []
                data.dataRows.map(item=>{
                    if(item.dataTemplateId === template.docsPdf){
                        this.pdfs.push(Object.assign({rId: item.id},item.detail))
                    }
                })
                this.videoList = data.dataRows.filter(item=>item.dataTemplateId === template.docsVideo)
                this.relatedProducts = data.dataRows.filter(item=>[template.relatedProducts,template.relatedProductsTech].includes(item.dataTemplateId))
                let cases = data.dataRows.filter(item=>item.dataTemplateId === template.productCase)
                if(cases.length){
                    this.cases = cases.reduce((pre,cur)=>{
                        if(!pre.includes(cur.detail.caseTitle)){
                            pre.push(cur.detail.caseTitle)
                        }
                        return pre
                    },[])
                }
            }
            this.$root.$emit('pageview',{
                title,
                tagIds: data.tagIds.join(',')
            })
            // let dataGroup = [dataDic[this.section], window.env.VUE_APP_DATA_DOCUMENT]
            // if (this.section === '工业 4.0') {
            //     dataGroup.push(dataDic['相关产品'], dataDic['案例'])
            // }
            // dataGroup = dataGroup.map(item => this.getJson(item))
            // const [products, docs, relatedProducts, cases] = await Promise.all(dataGroup)
            // const { index } = this.$route.query
            // this.product = products.find(item => {
            //     if (index) {
            //         return item.name === this.name && item.index === index
            //     }
            //     return item.name === this.name
            // })


            // if (this.product.relatedProducts) {
            //     const names = this.product.relatedProducts.split(';')
            //     this.relatedProducts = products.filter(item => names.includes(item.name))
            // }

            // // 相关产品
            // if (Array.isArray(relatedProducts)) {
            //     this.relatedProducts = relatedProducts.filter(item => item.index === this.product.name)
            // }
            // // 应用案例
            // if (Array.isArray(cases)) {
            //     this.cases = cases.reduce((pre, cur) => {
            //         if (cur.index === this.product.name) {
            //             if (!pre.includes(cur.caseTitle)) {
            //                 pre.push(cur.caseTitle)
            //             }
            //         }
            //         return pre
            //     }, [])
            // }

            // 绑定图片和视频
            this.$nextTick(() => {
                const content = document.querySelector('.product-detail-container .content')
                Array.prototype.forEach.call(content.querySelectorAll('img'), (item, index) => {
                    const src = this.product.imgGroup.split(/[;；]/)[index]
                    const suffix = getSuffix(src)
                    const processer = getImgProcesser(getResizeParam(item), suffix)
                    item.src = src + processer
                })
                Array.prototype.forEach.call(content.querySelectorAll('video'), ((item, index) => {
                    const src = this.product.videoGroup.split(/[;；]/)[index]
                    item.src = src
                    item.controls = 'true'
                    const query = getVideoProcesser(item, getResizeParam(item))
                    item.poster = src + query
                }))
                Array.prototype.forEach.call(content.querySelectorAll('a'), ((item) => {
                    item.addEventListener('click', (e) => {
                        this.jump(e.target.href)
                        e.preventDefault()
                    })
                }))
            })
            // const pdfIds = this.product.pdfIds.toString().split(';')
            // this.pdfs = pdfIds.map(id => {
            //     return docs.find(doc => doc.type === 'pdf' && doc.id == id)
            // })
        }
    },
    watch: {
        'rId': {
            handler(v) {
                this.relatedProducts = this.cases = null
                this.initData()
            },
            immediate: true
        }
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets//style/var';
.content-wrapper {
    padding: 1.2rem 1rem;
    .banner {
        width: 100%;
        object-fit: contain;
        // object-position: center;
        margin: 1.2rem 0 0.8rem;
        display: block;
    }
}
.pdf-wrapper {
    border-top: 3px solid #f2f2f2;
    padding: 1.2rem 1rem;
    .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.8rem;
        h4 {
            font-size: 0.8rem;
        }
        .more {
            font-size: 0.7rem;
            color: @themeColor;
        }
    }
}
.cases-wrapper {
    padding: 1.2rem 1rem;
    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #64a7b1;
        &::after {
            content: '';
            background: url('~@/assets/imgs/arrow.png') no-repeat center/contain;
            width: 0.6rem;
            height: 0.6rem;
        }
    }
}
.button-group {
    display: flex;
    flex-wrap: wrap;
    line-height: 1;
    padding: 1.2rem 1rem;
    justify-content: space-between;
    border-top: 3px solid #f2f2f2;
    .button-item {
        padding: 0.6rem 2.25rem;
        margin-bottom: 1.2rem;
    }
}

</style>
<style lang="less">
@import '~@/assets/style/mixin.less';
.product-detail-container {
    .content {
        line-height: 1.2rem;
        font-size: 0.65rem;
        padding: 1.2rem 0;
        text-align: justify;
        img {
            width: 100%;
            margin-bottom: 1rem;
        }
        ul {
            list-style-type: disc;
            margin-left: 1rem;
        }
        h5,
        a {
            line-height: 2rem;
            font-size: 1em;
        }
        video {
            width: 100%;
            object-fit: contain;
            margin: 0.8rem 0 1.2rem;
        }
        a {
            color: #64a7b1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &::after {
                content: '';
                .arrow(right,0.3rem,#64a7b1);
            }
        }
    }
}
</style>